export const CANONICAL_UNITS = [
  // volume
  "teaspoon", "tablespoon", "cup", "fl-oz", "ml", "l",
  // mass
  "g", "kg", "oz", "lb",
  // count/other (require per-ingredient gram weights)
  "whole", "clove", "can", "slice", "piece", "stalk", "bunch", "head", "fillet", "link", "pinch",
] as const;

export type CanonicalUnit = (typeof CANONICAL_UNITS)[number];

export function isCanonicalUnit(unit: string): unit is CanonicalUnit {
  return (CANONICAL_UNITS as readonly string[]).includes(unit);
}

/**
 * Purchase units the grocery unit picker offers for a line whose recipe
 * demand is unquantified (spec 2026-09-13 §4). Display order. These are
 * how things are BOUGHT, not measured, so they sit apart from
 * CANONICAL_UNITS; "can" appears in both and the picker de-duplicates.
 */
export const GROCERY_PACKAGE_UNITS = ["item", "package", "container", "bag", "bottle", "jar", "can"] as const;
export type GroceryPackageUnit = (typeof GROCERY_PACKAGE_UNITS)[number];
